import { createSelector } from 'reselect';
import { horizontalSizeSelectorSelector } from 'selectors/testTarget/offers/horizontalSizeSelector/horizontalSizeSelectorSelector';

const showSelector = createSelector(horizontalSizeSelectorSelector, horizontalSizeSelector => !!horizontalSizeSelector.show);

export { showSelector };
